/**
 * KD3 S2566 (NFR-NOTIF-003): ปุ่มในแถวรายการถูกถอดจาก DOM ทันทีหลังกด
 * ("อ่านแล้ว" → ปุ่มหาย · "ลบ" → ทั้งแถวหาย) โฟกัสของผู้ใช้คีย์บอร์ดจึงหล่นไป <body>
 * ต้อง Tab ใหม่ ~70 ครั้งกว่าจะกลับถึงกระดิ่ง (WCAG 2.4.3 Focus Order)
 *
 * เรียก **ก่อน** เปลี่ยน state — ย้ายโฟกัสไปยัง element ที่จะยังอยู่หลัง re-render ตามลำดับ:
 *   1. ปุ่ม/ลิงก์ถัดไปในกลุ่มเดียวกัน (เมื่อแถวยังอยู่ เช่น กดอ่านแล้ว → ไปปุ่มลบของแถวเดิม)
 *   2. ปุ่มแรกของแถวถัดไป หรือแถวก่อนหน้า (เมื่อแถวถูกลบ)
 *   3. fallback ที่ผู้เรียกให้มา (เช่น ปุ่มปิด panel)
 * คืน element ที่ได้รับโฟกัส (null = ไม่มีที่ให้ย้าย)
 */
const FOCUSABLE = 'button:not([disabled]), a[href]';

export function focusAfterRowAction(
  button: HTMLElement,
  opts: { rowSelector: string; removesRow: boolean; fallback?: HTMLElement | null },
): HTMLElement | null {
  const row = button.closest<HTMLElement>(opts.rowSelector);
  let target: HTMLElement | null = null;

  if (!opts.removesRow) {
    let sib = button.nextElementSibling as HTMLElement | null;
    while (sib && !sib.matches(FOCUSABLE)) sib = sib.nextElementSibling as HTMLElement | null;
    target = sib;
  }
  if (!target && row) {
    const neighbor = (row.nextElementSibling ?? row.previousElementSibling) as HTMLElement | null;
    target = neighbor?.querySelector<HTMLElement>(FOCUSABLE) ?? null;
  }
  if (!target) target = opts.fallback ?? null;

  target?.focus();
  return target;
}
